// Mirrors the real backend enum (entities/BillingStatementPlaceholder.ts BILLING_STATEMENT_STATUSES)
// -- DRAFT/PARTIALLY_PAID never existed there; no statement is ever created with either, so they
// were dead filter options. Status is rendered via getDisplayStatus (helpers/billingStatement.js),
// not this list directly -- this only feeds the status filter dropdown now.
export const BILLING_STATEMENT_STATUSES = [
  "ISSUED",
  "PAID",
  "OVERDUE",
  "VOID",
];

// Statuses that can still receive a payment. Mirrors the API's PAYABLE_STATUSES.
export const PAYABLE_STATUSES = ["ISSUED", "OVERDUE"];
